import { styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const TicketAdvancedLayout = styled(Paper)({
    height: "100%",
    display: "grid",
    gridTemplateRows: "minmax(0, 1fr)"
})

export default TicketAdvancedLayout;